import { useLanguage } from "@/lib/language";

const copy = {
  cost_guide_insert: {
    heading: {
      en: "Compare what the quotations include",
      ar: "قارن ما تشمله عروض الأسعار",
    },
    body: {
      en: "Reviewing ISO offers? Use the blank workbook to compare up to three providers against the same activities, sites and buyer requirement. Record what is included and which points still need a written answer.",
      ar: "تراجع عروضاً لشهادات الأيزو؟ استخدم ملف المقارنة الفارغ لمقارنة ما يصل إلى ثلاثة مقدمي خدمة على أساس الأنشطة والمواقع ومتطلب المشتري نفسه. دوّن ما يشمله كل عرض والنقاط التي ما زالت تحتاج إلى إجابة مكتوبة.",
    },
    link_label: {
      en: "Download the quotation comparison workbook (XLSX, English + Arabic)",
      ar: "حمّل ملف مقارنة عروض الأسعار (XLSX، بالعربية والإنجليزية)",
    },
    href: "/resources/iso-quotation-scope-comparison-en-ar.xlsx",
    microcopy: {
      en: "Two language sheets with blank fields for your own offers.",
      ar: "ورقتا عمل بالعربية والإنجليزية، بخانات فارغة للعروض التي تلقيتها.",
    },
  },
  comparison_guide_insert: {
    before_link: {
      en: "To compare your own offers, ",
      ar: "لمقارنة العروض التي تلقيتها، ",
    },
    link_label: {
      en: "download the blank comparison workbook",
      ar: "حمّل ملف المقارنة الفارغ",
    },
    after_link: {
      en: " (XLSX, English + Arabic). Record up to three providers’ stated scope and the questions each still needs to answer.",
      ar: " (XLSX، بالعربية والإنجليزية). دوّن نطاق كل عرض والأسئلة التي ما زال على مقدم الخدمة الإجابة عنها. يتّسع الملف لعروض ثلاثة مقدمي خدمة كحد أقصى.",
    },
    href: "/resources/iso-quotation-scope-comparison-en-ar.xlsx",
  },
};

/** Keep the file-format token legible within either reading direction. */
function FormatText({ text }: { text: string }) {
  return text.split(/(XLSX)/).map((part, index) =>
    part === "XLSX" ? (
      <bdi key={index} dir="ltr">
        XLSX
      </bdi>
    ) : (
      part
    ),
  );
}

/** Ungated, local-file worksheet; entries are never sent to IraqCert. */
export function QuotationWorkbookDownload({ variant }: { variant: "cost" | "comparison" }) {
  const { t } = useLanguage();
  if (variant === "comparison") {
    const content = copy.comparison_guide_insert;
    return (
      <p className="mt-4 text-base leading-relaxed text-muted-foreground">
        {t(content.before_link)}
        <a
          href={content.href}
          download
          className="font-semibold text-primary underline underline-offset-2"
        >
          {t(content.link_label)}
        </a>
        <FormatText text={t(content.after_link)} />
      </p>
    );
  }
  const content = copy.cost_guide_insert;
  return (
    <section
      className="mt-8 rounded-2xl border border-border bg-accent p-5 sm:p-6"
      aria-labelledby="quotation-workbook-title"
    >
      <h2 id="quotation-workbook-title" className="text-xl font-bold text-foreground">
        {t(content.heading)}
      </h2>
      <p className="mt-3 text-base leading-relaxed text-muted-foreground">{t(content.body)}</p>
      <a
        href={content.href}
        download
        className="mt-4 inline-block font-semibold text-primary underline underline-offset-2"
      >
        <FormatText text={t(content.link_label)} />
      </a>
      <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{t(content.microcopy)}</p>
    </section>
  );
}
